/* eslint-disable max-lines */
import React, { useEffect, useState } from 'react'
import styled, { css } from 'styled-components'
import { useSelector } from 'react-redux'
import { AddMapView, MapVisualizationModal, NestedSelect, Pagination } from '@dataplace.ai/ui-components/molecules'
import PerfectScrollbar from 'react-perfect-scrollbar'
import {
  LinkWithIconCheckOnMap,
  // SimpleSelect,
  TitleFormSectionSubTitle,
  MapTile,
  IMapLocationProps,
} from '@dataplace.ai/ui-components/atoms'
import { Table } from '@dataplace.ai/ui-components/organisms'
import { useTranslation } from 'react-i18next'
import { ResourceWithId } from '@dataplace.ai/ui-components/organisms/ResourcesSelector/@types/ResourceWithId'
import { IFeatureCollection } from '@dataplace.ai/ui-components/atoms/MapTile/components/MapOverlays/@types/IFeatureCollection'
import { Loader } from 'libs/shared/ui-components/src/atoms'
import { saveTileData, saveTiles } from 'apps/placeme/src/features/Analyse/slice/analysisSlice'
import { useAppDispatch } from 'apps/placeme/src/redux/hooks'
import { BasicLayers, GeojsonLayers, WMSLayers, FeatureCollectionLayers } from '@dataplace.ai/ui-components/atoms/MapTile/@types/LayersTypes'
import { IGeojson } from '@dataplace.ai/ui-components/atoms/MapTile/components/MapOverlays/@types/IGeojson'
import { investmentsTableData } from './data'
import { RootState } from '../../../../../../../redux/store'
import { IInvestment, IInvestmentsTileData } from './@types/IInvestmentsTileData'
import { ComparedLocationHeader } from '../../../../atoms'

const { v4: uuidv4 } = require('uuid')

const Wrapper = styled.div(({ theme }) => {
  const { palette } = theme
  return css`
    display: flex;
    flex-direction: column;
    padding: 1.25rem 1.5rem;
    background-color: ${palette.light.white};
  `
})
const TitleWithLegend = styled.span(({ theme }) => {
  const {
    palette, typography,
  } = theme
  return css`
    margin: 1rem 0 0;
    display: flex;
    flex-direction: row;
    color: ${palette.black};
    background-color: ${palette.light.white};
    font-size: ${typography.main.pt_15_semibold.fontSize};
    font-weight: ${typography.main.pt_15_semibold.fontWeight};
    line-height: ${typography.main.pt_15_semibold.lineHeight};

    > img{
      width: 22px;
      height: 22px;
      margin-right: 10px;
    }
  `
})

const NestedSelectWrapper = styled.div(({ theme }) => {
  const {
    palette, typography,
  } = theme
  return css`
    display: flex;
    flex-direction: row;
    align-items: center;
    white-space: nowrap;
    color: ${palette.black};
    font-size: ${typography.small.pt_13_regular.fontSize};
    font-weight: ${typography.small.pt_13_regular.fontWeight};
    line-height: ${typography.small.pt_13_regular.lineHeight};

    > span {
      margin-right: 0.5rem;
    }
  `
})

// const SimpleSelectWrapper = styled.div(({ theme }) => {
//   const {
//     palette, typography,
//   } = theme
//   return css`
//     display: flex;
//     flex-direction: row;
//     justify-content: flex-end;
//     align-items: center;
//     white-space: nowrap;
//     color: ${palette.blue};
//     font-size: ${typography.small.pt_13_regular.fontSize};
//     font-weight: ${typography.small.pt_13_regular.fontWeight};
//     line-height: ${typography.small.pt_13_regular.lineHeight};

//     > span {
//       color: ${palette.black};
//       margin-right: 0.5rem;
//     }
//   `
// })

const MapWrapper = styled.div(
  () => css`
    margin: 1rem 0;
    width: 100%;
    height: 300px;
  `,
)

const StyledTitleFormSectionSubTitle = styled(TitleFormSectionSubTitle)(
  ({ theme }) => {
    const { palette } = theme
    return css`
      border-top: 1px solid ${palette.light.darker};
      padding-top: 2rem;
      margin-bottom: 0;
    `
  },
)

const AdditionalInfo = styled.div(({ theme }) => {
  const {
    palette, typography,
  } = theme
  return css`
    display: flex;
    padding: 0.5rem;
    border-top: 1px solid ${palette.light.darker};
    flex-direction: row;
    flex-wrap: wrap;

    div {
      display: flex;
      flex-direction: column;
      margin: 0.5rem 0;
    }

    > div {
      width: 50%;
    }

    > div:last-child {
      width: 100%;
    }

    > div > span:first-child,
    > div > div > span:first-child {
      margin-bottom: 0.25rem;
      color: ${palette.dark.normal};
      font-size: ${typography.tiny.pt_12_medium_upper.fontSize};
      font-weight: ${typography.tiny.pt_12_medium_upper.fontWeight};
      line-height: ${typography.tiny.pt_12_medium_upper.lineHeight};
      letter-spacing: ${typography.tiny.pt_12_medium_upper.letterSpacing};
      text-transform: ${typography.tiny.pt_12_medium_upper.textTransform};
    }

    > div > div > span {
      color: ${palette.black};
      font-size: ${typography.small.pt_13_semibold.fontSize};
      font-weight: ${typography.small.pt_13_semibold.fontWeight};
      line-height: ${typography.small.pt_13_semibold.lineHeight};
      letter-spacing: ${typography.small.pt_13_semibold.letterSpacing};
      text-transform: ${typography.small.pt_13_semibold.textTransform};
    }

    > div > span {
      color: ${palette.black};
      font-size: ${typography.small.pt_13_regular.fontSize};
      font-weight: ${typography.small.pt_13_regular.fontWeight};
      line-height: ${typography.small.pt_13_regular.lineHeight};
      letter-spacing: ${typography.small.pt_13_regular.letterSpacing};
      text-transform: ${typography.small.pt_13_regular.textTransform};
    }
  `
})
const ObjectWrapper = styled.div`
  display: flex;
  flex-direction: column;
`
const ScrollWrapper = styled.div`
  margin: 1rem 0;
  max-height: 650px;
  overflow-y: auto;
  overscroll-behavior: contain;

/* ::-webkit-scrollbar { */
  /* display: none;  /* Chrome, Safari and Opera */
/*} */

-ms-overflow-style: none;  /* IE and Edge */
  /* scrollbar-width: none;  Firefox */
  .ps{
    overflow: visible !important;
  }
`

interface ExpandableProps {
  investorName: string,
  legalStatus?: string,
  dateOfApplication: string,
  capacity: number | string,
  info: string
}

const Expandable: React.FC<ExpandableProps> = ({
  investorName, legalStatus, dateOfApplication, capacity, info,
}) => {
  const { t } = useTranslation()

  return (
    <AdditionalInfo>
      <div>
        <div>
          <span>{`${t('placeme.investments_tile.investor_name')}:`}</span>
          <span>
            {(typeof investorName === 'string' && (investorName.toLowerCase() === 'none'
          || investorName.toLowerCase() === 'nan'))
              ? '-'
              : investorName}

          </span>
        </div>
        { legalStatus && (
          <div>
            <span>{`${t('placeme.investments_tile.legal_status')}:`}</span>
            <span>{legalStatus}</span>
          </div>
        )}
        { !legalStatus && (
          <div>
            <span>{`${t('placeme.investments_tile.info')}:`}</span>
            <span>{info}</span>
          </div>
        )}
      </div>
      <div>
        <div>
          <span>{`${t('placeme.investments_tile.date_of_application')}:`}</span>
          <span>{dateOfApplication}</span>
        </div>
        <div>
          <span>{`${t('placeme.investments_tile.capacity')}:`}</span>
          <span>
            {(typeof capacity === 'string' && (capacity.toLowerCase() === 'none'
          || capacity.toLowerCase() === 'nan'))
              ? '-'
              : `${capacity} m2`}

          </span>
        </div>
      </div>
      <div>
        {legalStatus
        && (
          <>
            <span>{`${t('placeme.investments_tile.info')}:`}</span>
            <span>{info}</span>
          </>
        )}
      </div>
    </AdditionalInfo>
  )
}

export const getInvestmentIcon: (category: string) => string = (category) => {
  switch (category) {
    case 'administration':
      return 'assets/icons/placeme/administrationInvestments.svg'
    case 'residential':
      return 'assets/icons/placeme/residentialInvestments.svg'
    case 'retail_and_services':
      return 'assets/icons/placeme/servicesInvestments.svg'
    case 'other':
      return 'assets/icons/placeme/otherInvestments.svg'
    case 'economic':
      return 'assets/icons/placeme/economicInvestments.svg'
    case 'infrastructural':
      return 'assets/icons/placeme/infrastructuralInvestments.svg'
    default:
      return 'assets/icons/placeme/otherInvestments.svg'
  }
}

export const InvestmentsTile: React.FC<{
  data: IInvestmentsTileData,
  tileId: string
}> = ({
  data,
  tileId,
}) => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const [val, setValue] = useState<ResourceWithId[]>([])
  // const [sort, setSort] = useState<string>(t('placeme.sort.distance_descending'))
  const [mapVisible, setMapVisible] = useState<boolean>(false)
  const [comparedMapVisible, setComparedMapVisible] = useState<boolean>(false)
  const [categories, setCategories] = useState<ResourceWithId[]>([])
  const { labels } = investmentsTableData
  const { value } = useSelector((state: RootState) => state.location)
  const {
    values, comparedLocation,
  } = useSelector((state: RootState) => state.analysis)

  const [isMapDisplayed, setIsMapDisplayed] = useState(false)
  const [isComparedMapDisplayed, setIsComparedMapDisplayed] = useState(false)
  const [valuesToDisplay, setValuesToDisplay] = useState<{[key: string]: IInvestment[]}>({})
  const [comparedValuesToDisplay, setComparedValuesToDisplay] = useState<{[key: string]: IInvestment[]}>({})
  const [mapLocation, setMapLocation] = useState<IMapLocationProps>({
    zoom: 14,
    center: {
      lat: value?.lat || 0,
      lng: value?.lng || 0,
    },
  })
  const [comparedMapLocation, setComparedMapLocation] = useState<IMapLocationProps>({
    zoom: 14,
    center: {
      lat: comparedLocation?.location?.lat || 0,
      lng: comparedLocation?.location?.lng || 0,
    },
  })

  const catchmentId = values?.find(c => c.id === 'surroundings')?.tiles?.find(t =>
    t.id === tileId)?.chosenRange?.catchmentId

  const handleMapOpen = (compared: boolean) => {
    if (compared) { setIsComparedMapDisplayed(!isComparedMapDisplayed) }
    else { setIsMapDisplayed(!isMapDisplayed) }
  }

  const getLayers = (categories: string[], compared: boolean) => {
    const items = compared ? data?.value?.comparedLocation : data?.value
    if (items) {
      const features : IFeatureCollection['data']['features'] = []
      const tile = values?.find(c => c.id === 'surroundings')?.tiles?.find(t =>
        t.id === tileId)
      const rangeCoords = compared
        ? tile?.comparedChosenRange?.geoJSON?.coordinates
        : tile?.chosenRange?.geoJSON?.coordinates
      items?.investments?.forEach(invest => {
        if (categories.includes(invest?.category)) {
          features.push({
            geometry: {
              coordinates: [invest?.lng, invest?.lat],
              type: 'Point',
            },
            properties: {
              title: `<div style="display: flex; flex-direction: column;"><span>${handleTranslateForInvestName(invest?.name)}</span><span>${invest?.address}</span></div>`,
              pinnedItem: {
                iconAnchor:[11, 11],
                class: 'poi-img',
                html: `<img alt='' src='${getInvestmentIcon(invest?.category)}'/>`,
              },
            },
            type: 'Feature',
          }) } })

      const layers: (BasicLayers | GeojsonLayers | WMSLayers | FeatureCollectionLayers)[] = [
        {
          id: 'investment-layer',
          layer: {
            data: {
              features,
              type: 'FeatureCollection',
            },
            options: {
              type: 'geojson',
              id: 'investments',
            },
          },
        }]
      // range layer
      if (rangeCoords) {
        layers.push({
          id: (compared ? `${tile?.id}-compared` : tile?.id) || '',
          layer: {
            data: {
              coordinates: (rangeCoords) as IGeojson['data']['coordinates'],
              type: 'Polygon',
              properties: {},
            },
            options:{
              type: 'geojson',
              id: compared ? 'invest_range_compared' : 'invest_range',
              style: {
                color: '#0000a2',
                fillColor:'#0000a2',
                weight: 1.5,
                fillOpacity: 0.05,
              },
            },
          },
        })
      }

      return layers
    }
    return undefined
  }

  const handleAddMap = (compared: boolean) => {
    if (compared) { setComparedMapVisible(true) }
    else { setMapVisible(true) }
  }

  const handleTranslateForInvestName = (name: string) => t(`placeme.investments_tile.name.${name.toLocaleLowerCase().split(/[_/ -]+/)
    .join('_')}`)

  const getCatchmentId = values?.find(c => c.id === 'surroundings')?.tiles?.find(t => t.id === tileId)?.chosenRange?.catchmentId

  useEffect(() => {
    if (data?.value) {
      const categoriesObjects : { id: string, content: string}[] = []
      data?.value?.investments?.forEach(investment => {
        const categoryId = investment?.category === 'nan' ? 'other' : investment?.category
        if (!categoriesObjects.find(cat => cat?.id === categoryId)) {
          categoriesObjects.push({
            id: categoryId,
            content: t(`placeme.investments_tile.category.${categoryId.split(' ').join('_')}`),
          })
        }
      })

      if (data?.value?.comparedLocation) {
        data?.value?.comparedLocation?.investments?.forEach(investment => {
          const categoryId = investment?.category === 'nan' ? 'other' : investment?.category
          if (!categoriesObjects.find(cat => cat?.id === categoryId)) {
            categoriesObjects.push({
              id: categoryId,
              content: t(`placeme.investments_tile.category.${categoryId.split(' ').join('_')}`),
            })
          }
        })
      }

      setCategories(categoriesObjects)
      setValue(categoriesObjects)
    }
  }, [data?.value])

  useEffect(() => {
    if (data?.value?.investments?.length) {
      // save categories for pdf
      const toExclude = categories?.filter(cat =>
        !val?.map(item => item?.id).includes(cat?.id)).map(item => item?.id)
      if (catchmentId && toExclude?.length) {
        const pdfTiles = values?.map(cat => {
          if (cat?.id === 'surroundings') {
            return {
              ...cat,
              tiles: cat?.tiles.map(tile => {
                if (tile?.chosenRange?.catchmentId === catchmentId) {
                  return {
                    ...tile,
                    pdfExcluded:toExclude,
                  }
                } return tile
              }),

            }
          }
          return cat
        })
        dispatch(saveTiles(pdfTiles))
      }

      const sortedValues: {[key: string]: IInvestment[]} = {}

      data?.value?.investments.filter(v => val.map(v => v.id)?.includes(v.category)).forEach(invest => {
        if (!sortedValues[invest?.category]) {
          sortedValues[invest?.category] = []
        }
      })

      data?.value?.investments?.filter(v => val.map(v => v.id)?.includes(v.category))
        ?.sort((a, b) => (a.distanceFromPoint < b.distanceFromPoint ? -1 : 1))
        ?.forEach(v => sortedValues[v?.category]?.push(v))

      setValuesToDisplay(sortedValues || [])

      if (data?.value?.comparedLocation) {
        const sortedComparedValues: {[key: string]: IInvestment[]} = {}

        data?.value?.comparedLocation?.investments.filter(v =>
          val.map(v => v.id)?.includes(v.category)).forEach(invest => {
          if (!sortedComparedValues[invest?.category]) {
            sortedComparedValues[invest?.category] = []
          }
        })

        data?.value?.comparedLocation?.investments?.filter(v => val.map(v => v.id)?.includes(v.category))
          ?.sort((a, b) => (a.distanceFromPoint < b.distanceFromPoint ? -1 : 1))
          ?.forEach(v => sortedComparedValues[v.category].push(v))

        setComparedValuesToDisplay(sortedComparedValues || [])
      }
    }
  }, [val])

  useEffect(() => {
    if (data?.value?.investments?.length && mapLocation) {
      dispatch(saveTileData('surroundings', tileId, {
        ...data,
        mapLocation,
        comparedMapLocation: data?.value?.comparedLocation ? comparedMapLocation : undefined,
      }))
    }
  }, [mapLocation, comparedMapLocation])

  return !data?.value || data?.loading
    ? (<Loader />)
    : (
      <Wrapper>
        <NestedSelectWrapper>
          <span>{t('placeme.investments_tile.investment_categories')}</span>
          <NestedSelect
            name=''
            onChange={setValue}
            options={categories?.map(item => ({
              id: item?.id,
              content: t(`placeme.investments_tile.category.${item?.id.split(' ').join('_')}`),
            }))}
            selected={val?.map(item => ({
              id: item?.id,
              content: t(`placeme.investments_tile.category.${item?.id.split(' ').join('_')}`),
            }))}
            width='50%'
          />
        </NestedSelectWrapper>
        {data?.value?.comparedLocation && (
          <ComparedLocationHeader>
            <h5>{t('placeme.municipality_population.compared_location.header_1')}</h5>
            {' '}
            <span>{value?.address}</span>
          </ComparedLocationHeader>
        )}
        { Object.entries(valuesToDisplay).map((v) => (
          <ObjectWrapper key={uuidv4()}>
            <TitleWithLegend>
              <img
                alt=''
                src={getInvestmentIcon(v[0])}
              />
              {t(`placeme.investments_tile.category.${v[0].split(' ').join('_')}`)}
            </TitleWithLegend>
            <ScrollWrapper>
              <PerfectScrollbar
                className='scroll'
              >

                <Pagination
                  data={(v[1].map(val => [(val?.name.toLowerCase() === 'nan') ? '-' : handleTranslateForInvestName(val?.name),
                    val?.address, val?.distanceFromPoint * 1000,
                    val?.capacity, val?.dateOfApplication, val?.info, val?.investorName,
                    val?.legalStatus])) as string[][]}
                  dataLimit={8}
                  justifyNavigation='center'
                  renderComponent={(data) => {
                    const newData = data as string[]
                    return (
                      <Table
                        content={newData.map(d => [<span key={uuidv4()}>{d[0]}</span>,
                          <span key={uuidv4()}>{d[1]}</span>,
                          <span key={uuidv4()}>{`${d[2]} m`}</span>])}
                        expandableComponent={newData.map(item => (
                          <Expandable
                            key={uuidv4()}
                            capacity={item[3]}
                            dateOfApplication={item[4]}
                            info={item[5]}
                            investorName={item[6]}
                            // legalStatus={item[7]}
                          />
                        ))}
                        gap='1rem'
                        headerTemplate='5fr 3fr 4fr 1fr'
                        headerTextAlign='left'
                        labels={labels.map((label) => (
                          <span key={label}>{t(label)}</span>
                        ))}
                        rowTemplate='5fr 3fr 4fr 1fr'
                        whiteSpaces='wrap'
                      />
                    ) }}
                />

              </PerfectScrollbar>
            </ScrollWrapper>
          </ObjectWrapper>
        ))}

        {(mapVisible) && (
          <>
            <StyledTitleFormSectionSubTitle>
              <span>{t('placeme.investments_tile.points_on_map')}</span>
              <LinkWithIconCheckOnMap onClick={() => handleMapOpen(false)} />
            </StyledTitleFormSectionSubTitle>
            <MapWrapper>
              <MapTile
                height='100%'
                layers={getLayers(Object.keys(valuesToDisplay), false)}
                location={value}
                mapId='example-map-data-tile'
                pinDisplayed
                popupHeading={`${t('generic.chosen_location')}:`}
                popupParagraph={value?.address}
                setMapLocation={setMapLocation}
                showScaleControl
                width='100%'
                zoomControl
              />
            </MapWrapper>
          </>
        )}
        {(!mapVisible) && (
          <AddMapView
            buttonValue={0}
            description='placeme.add_investments_map.description'
            onChange={() => handleAddMap(false)}
            title='placeme.add_investments_map.title'
          />
        )}
        {isMapDisplayed && (
          <MapVisualizationModal
            isDisplayed={isMapDisplayed}
            layers={getLayers(Object.keys(valuesToDisplay), false)}
            location={value}
            mapId={`investment-map-${getCatchmentId}`}
            setIsDisplay={setIsMapDisplayed}
          />
        )}

        {data?.value?.comparedLocation
        && (
          <>
            <ComparedLocationHeader second>
              <h5>{t('placeme.municipality_population.compared_location.header_2')}</h5>
              {' '}
              <span>{comparedLocation?.location?.address}</span>
            </ComparedLocationHeader>
            { Object.entries(comparedValuesToDisplay).map((v) => (
              <ObjectWrapper key={uuidv4()}>
                <TitleWithLegend>
                  <img
                    alt=''
                    src={getInvestmentIcon(v[0])}
                  />
                  {t(`placeme.investments_tile.category.${v[0].split(' ').join('_')}`)}
                </TitleWithLegend>
                <ScrollWrapper>
                  <PerfectScrollbar
                    className='scroll'
                  >

                    <Pagination
                      data={(v[1].map(val => [(val?.name.toLowerCase() === 'nan') ? '-' : handleTranslateForInvestName(val?.name),
                        val?.address, val?.distanceFromPoint * 1000,
                        val?.capacity, val?.dateOfApplication, val?.info, val?.investorName,
                        val?.legalStatus])) as string[][]}
                      dataLimit={8}
                      justifyNavigation='center'
                      renderComponent={(data) => {
                        const newData = data as string[]
                        return (
                          <Table
                            content={newData.map(d => [<span key={uuidv4()}>{d[0]}</span>,
                              <span key={uuidv4()}>{d[1]}</span>,
                              <span key={uuidv4()}>{`${d[2]} m`}</span>])}
                            expandableComponent={newData.map(item => (
                              <Expandable
                                key={uuidv4()}
                                capacity={item[3]}
                                dateOfApplication={item[4]}
                                info={item[5]}
                                investorName={item[6]}
                                // legalStatus={item[7]}
                              />
                            ))}
                            gap='1rem'
                            headerTemplate='5fr 3fr 4fr 1fr'
                            headerTextAlign='left'
                            labels={labels.map((label) => (
                              <span key={label}>{t(label)}</span>
                            ))}
                            rowTemplate='5fr 3fr 4fr 1fr'
                            whiteSpaces='wrap'
                          />
                        ) }}
                    />

                  </PerfectScrollbar>
                </ScrollWrapper>
              </ObjectWrapper>
            ))}

            {(comparedMapVisible && data?.value?.comparedLocation) && (
              <>
                <StyledTitleFormSectionSubTitle>
                  <span>{t('placeme.investments_tile.points_on_map')}</span>
                  <LinkWithIconCheckOnMap onClick={() => handleMapOpen(true)} />
                </StyledTitleFormSectionSubTitle>
                <MapWrapper>
                  <MapTile
                    height='100%'
                    layers={getLayers(Object.keys(comparedValuesToDisplay), true)}
                    location={comparedLocation?.location}
                    mapId='example-map-data-tile_compared'
                    pinDisplayed
                    popupHeading={`${t('generic.chosen_location')}:`}
                    popupParagraph={comparedLocation?.location?.address}
                    setMapLocation={setComparedMapLocation}
                    showScaleControl
                    width='100%'
                    zoomControl
                  />
                </MapWrapper>
              </>
            )}
            {(!comparedMapVisible) && (
              <AddMapView
                buttonValue={0}
                description='placeme.add_investments_map.description'
                onChange={() => handleAddMap(true)}
                title='placeme.add_investments_map.title'
              />
            )}
            {isComparedMapDisplayed && (
              <MapVisualizationModal
                isDisplayed={isComparedMapDisplayed}
                layers={getLayers(Object.keys(comparedValuesToDisplay), true)}
                location={comparedLocation?.location}
                mapId={`investment-map-${getCatchmentId}_compared`}
                setIsDisplay={setIsComparedMapDisplayed}
              />
            )}
          </>
        )}

      </Wrapper>
    )
}
